// extracted by mini-css-extract-plugin
module.exports =  {"tc-split-dropdown":"ActionSplitDropdown-module__tc-split-dropdown___S6DCy"};